// angular
import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
// types
import { ProductClimaticType } from '@app/+products/shared/types/product-climatic.type';

@Component({
  selector: 'pwj-product-climatic-properties',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './product-climatic-properties.component.html',
  styleUrl: './product-climatic-properties.component.scss',
})
export class ProductClimaticPropertiesComponent {
  // inputs
  climaticData = input.required<ProductClimaticType>();
}
